// ======================================================================
// File Name       : ServiceNotificationListSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import * as FUNCTION from '../../../constants/FunctionConstants';
import * as ICON from '../../../constants/IconConstants';
import { VALIDATE_TYPE } from '../../../constants/index';
import * as Path from '../../../constants/PathConstants';
import { SELECT_BOX_DATA } from '../../../constants/SelectBoxData';
import { canAccessRoute } from '../../../utils/AuthedUtils';
import RenderField from '../../../utils/ReduxFormUtils';
import CustomButton from '../../button/CustomButton';
import CustomLink from '../../button/CustomLink';

class ServiceNotificationListSearch extends React.Component {
  render() {
    const {
      onSearchBtnClick,
      onExportBtnClick,
      recordNum,
      getStartEndData,
      invalid,
      publicStatus,
      userType,
    } = this.props;
    const canAccessImport = canAccessRoute(FUNCTION.SERVICE_NOTIFICATION_IMPORT);
    const canAccessRegister = canAccessRoute(FUNCTION.SERVICE_NOTIFICATION_REGISTER);
  
    return (
      <div>
        <p>検索する項目を指定してください</p>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className="form-horizontal margin-top-10">
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                タイトル
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="noticeTitle" label="タイトル" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                公開範囲
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="userType"
                  label="公開範囲"
                  value={userType}
                  data={SELECT_BOX_DATA.USER_TYPE}
                  normalizeRadio
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                公開ステータス
              </Col>
              <Col sm={7}>
                <RenderField
                  type="selectbox"
                  name="publicStatus"
                  label="公開ステータス"
                  value={publicStatus}
                  data={SELECT_BOX_DATA.PUBLIC_STATUS_ENTERPRISE_NOTIFICATION}
                  normalizeRadio
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                公開期間
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="publicDateFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center padding-top-10">
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="publicDateTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
            </Form.Group>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'publicDateFrom'}
                keyDateTo={'publicDateTo'}
              />
            </Col>
          </Col>
          <Col sm={12} className="text-center margin-top-10">
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              type="submit"
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
          <Col sm={12} className="text-right padding-left-right-clear margin-bottom-10">
            <Col sm={9} className="inline-flex padding-left-right-clear">
              {canAccessRegister && (
                <CustomLink
                  className="margin-right-7 btn-register margin-right-10"
                  to={Path.SERVICE_NOTIFICATION_REGISTER}
                  text="サービス向けお知らせの追加"
                  icon={ICON.REGIST}
                />
              )}
              {canAccessImport && (
                <CustomLink
                  className="margin-right-7 btn-csv-import"
                  to={Path.SERVICE_NOTIFICATION_IMPORT}
                  text="CSV一括投入"
                  icon={ICON.IMPORT}
                />
              )}
            </Col>
            <Col sm={3} className="padding-left-right-clear">
              <CustomButton
                btnStyle="btn btn-export-csv float-end"
                handleClick={onExportBtnClick}
                iconClass="bi bi-download"
                text="一括出力"
              />
            </Col>
          </Col>
        </Form>
      </div>
    );
  }
}

export default ServiceNotificationListSearch;
